const getStudentTeamIcons = (teams, studentId) =>
  teams
    .filter(({ members }) =>
      members.find(({ learnerId }) => learnerId === studentId),
    )
    .map(({ icon, name }) => ({ icon, name }));

export default getStudentTeamIcons;
